import { Button, Notification, Select } from "@rio-cloud/rio-uikit";
import { useIntl } from "react-intl";
import SuccessDialog from "../../../../dialogs/SuccessDialog";
import { IOccurrence, OccurrenceStatus } from "../../../types";
import { typeStatusOccurence } from "../../../constants";
import { useNavigateToBoard } from "../useNavigateToBoard";

interface IMoveStepDialogProps {
    show: boolean;
    id?: string | null;
    data?: IOccurrence | null;
    isDuplicated: boolean;
    closePage: boolean;
    isConsultant: boolean;
    selected: string[] | undefined;
    advanceStatus?: string[] | undefined;
    isLoadingEdit: boolean;

    setAdvanceStatus: (status: string[] | undefined) => void;
    setIsLoadingEdit: (isLoading: boolean) => void;
    setShowAdvanceStepDialog: (show: boolean) => void;
    handleNavigateCreate: () => void;
    updateOccurrence: () => Promise<void>;
    onClose: () => void;
}

export const MoveStepDialog = (props: IMoveStepDialogProps) => {

    const { 
        show, id, data, isDuplicated, closePage, isConsultant, selected, advanceStatus, isLoadingEdit,
        setAdvanceStatus, setIsLoadingEdit, setShowAdvanceStepDialog, onClose, updateOccurrence, handleNavigateCreate
    } = props;

    const intl = useIntl();
    const navigateToBoard = useNavigateToBoard();

    const tasStatusMap = {
        "OPEN": intl.formatMessage({ id: "intl-msg:tas.occurrence.card.open" }),
        "IN_ANALYSIS": intl.formatMessage({ id: "intl-msg:tas.occurrence.card.inAnalysis" }),
        "ANSWERED": intl.formatMessage({ id: "intl-msg:tas.occurrence.card.answered" }),
        "FINISHED": intl.formatMessage({ id: "intl-msg:tas.occurrence.card.finished" }),
    }

    const handleAdvanceStep = async () => {
        const status = advanceStatus?.[0] as OccurrenceStatus | undefined;

        if (!id || !data || !status) {
            return;
        }

        setIsLoadingEdit(true);

        try {
            await updateOccurrence();
            setShowAdvanceStepDialog(false);
            setAdvanceStatus(undefined);

            if (isDuplicated) {
                handleNavigateCreate();
            } else {
                if(closePage) {
                    navigateToBoard();
                }
            }

        } catch (error) {
            Notification.error('Não foi possível alterar a etapa no momento');
        } finally {
            setIsLoadingEdit(false);
        }
    };

    const handleCloseAdvanceStepDialog = () => {
        setShowAdvanceStepDialog(false);
        setAdvanceStatus(undefined);
        if(closePage) {
            navigateToBoard();
        }
    };

    const getAdvanceStatusOptions = () => {
        const status = selected?.[0] as OccurrenceStatus;

        const options = typeStatusOccurence.filter((type) => type.id !== status);

        return options?.map((type) => {
            return {
                ...type,
                disabled: isConsultant && type.id === 'OPEN',
            }
        })
    }

    return (
        <SuccessDialog
            show={show}
            title={intl.formatMessage({ id: "intl-msg:tas.occurrence.successAdvanceStepTitle" })}
            onClose={handleCloseAdvanceStepDialog}
            showCloseButton={false}
            body={(
                <div>
                    <div>
                        {intl.formatMessage({ id: "intl-msg:tas.occurrence.stepName" })} { }
                        <strong>
                            {tasStatusMap[selected?.[0] as keyof typeof tasStatusMap]}.
                        </strong>
                    </div>
                    <div className="mt-2">
                        { } {intl.formatMessage({ id: "intl-msg:tas.occurrence.changeStep" })}
                    </div>

                    <div className="width-100pct mt-2">
                        <label htmlFor="type">{intl.formatMessage({ id: "intl-msg:tas.occurrence.moveTo" })}</label>
                        <Select
                            id="advance-status"
                            bsSize='lg'
                            value={advanceStatus}
                            onChange={(item) => setAdvanceStatus(item?.id ? [item.id] : undefined)}
                            options={getAdvanceStatusOptions()}
                            disabled={isLoadingEdit}
                            placeholder={intl.formatMessage({ id: "intl-msg:tas.occurrence.stepSearchPlaceholder" })}
                        />
                    </div>
                </div>
            )}
            footer={(
                <Button
                    className={`btn btn-primary ${isLoadingEdit ? 'btn-loading disabled' : ''}`}
                    type="button"
                    disabled={isLoadingEdit || !advanceStatus?.[0]}
                    onClick={handleAdvanceStep}
                >
                    {intl.formatMessage({ id: "intl-msg:tas.occurrence.btn-close-save" })}
                </Button>
            )}
        />
    );
}